export default __webpack_public_path__ + "static/media/lds-logo_sr.e612d7d9e1e93de6.svg";